export default __webpack_public_path__ + "static/media/plus.38b0d8ad.svg";